import { render, staticRenderFns } from "./template-status-badge.vue?vue&type=template&id=2538e5e4&scoped=true&"
import script from "./template-status-badge.vue?vue&type=script&lang=js&"
export * from "./template-status-badge.vue?vue&type=script&lang=js&"
import style0 from "./template-status-badge.vue?vue&type=style&index=0&id=2538e5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2538e5e4",
  null
  
)

export default component.exports